export { default } from "./isHostComponent.mjs";